import React, { FC } from 'react'
import { List, ListProps } from '@mui/material'

export const EvtList: FC<ListProps> = ({ children, ...props }) => {
    return <List {...props}>{children}</List>
}

export default EvtList
